import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Button as AnimechUIButton, ButtonProps } from "@animech/ui";
import { FunctionComponent } from "react";

const ButtonWithProps: FunctionComponent<ButtonProps> = (props) => (
	<AnimechUIButton {...props} />
);

export const Button = styled(ButtonWithProps)`
	${() => {
		return css`
			background-color: #006539 !important;
		`;
	}}
`;
